import FilterTextField from '../baseInputTypes/FilterTextField'

export const RevisionNumber = () => (
  <FilterTextField
    label="Revision Number"
    fieldPath={'productInformation.revisionNo'}
  />
)
